export default __webpack_public_path__ + "static/media/681.93781d3a.png";